<template>
  <Modal v-model="addressLibraryModal" :title="addressLibraryTitle" width="700" @on-visible-change="addressLibraryChange"
    :transfer="false" :mask-closable="false" class-name="addressLibraryStyle" :footer-hide="addressLibraryType === 'look'">
    <Form ref="addressLibraryForm" :model="addressLibraryForm" :rules="ruleValidate" :disabled="addressLibraryType === 'look'"
      :label-width="labelWidth" @submit.native.prevent>
      <Row style="width: 90%;">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1001207')" prop="addressName">
            <Input :placeholder="$t('key1000324')" :maxlength="50" clearable v-model.trim="addressLibraryForm.addressName">
            </Input>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1002676')" prop="name">
            <Input v-model.trim="addressLibraryForm.name" :placeholder='$t("key1000324")' :maxlength="50" clearable></Input>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1002677')" prop="countryCode">
            <Select v-model.trim="addressLibraryForm.countryCode" filterable :disabled="addressLibraryType === 'edit'">
              <Option v-for="(talg,ids) in countrysOriginalData" :key="ids" :value="talg.twoCode">{{ talg.cnName }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1001162')" prop="state">
            <Input v-model.trim="addressLibraryForm.state" :placeholder='$t("key1000324")' :maxlength="255" clearable></Input>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1001164')" prop="city">
            <Input v-model.trim="addressLibraryForm.city" :placeholder='$t("key1000324")' :maxlength="255" clearable></Input>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1001166')" prop="district">
            <Input v-model.trim="addressLibraryForm.district" :placeholder='$t("key1000324")' :maxlength="255" clearable></Input>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1002678')" prop="street">
            <div class="position-relative">
              <Input v-model.trim="addressLibraryForm.street" :placeholder='$t("key1000324")' :maxlength="255" clearable></Input>
              <Tooltip placement="top" transfer max-width="400" :content="$t('key1002679')" class="promptStyle">
                <Icon class="cursor ml5" size="20" type="md-help-circle"></Icon>
              </Tooltip>
            </div>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1002680')" prop="street2">
            <Input v-model.trim="addressLibraryForm.street2" :placeholder='$t("key1000324")' :maxlength="255" clearable></Input>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1002681')" prop="street3">
            <Input v-model.trim="addressLibraryForm.street3" :placeholder='$t("key1000324")' :maxlength="255" clearable></Input>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1000067')" prop="phone">
            <Input v-model.trim="addressLibraryForm.phone" :placeholder='$t("key1000324")' :maxlength="255" clearable></Input>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1001170')" prop="postcode">
            <Input v-model.trim="addressLibraryForm.postcode" :placeholder='$t("key1000324")' :maxlength="10" clearable></Input>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1002682')" prop="company">
            <Input v-model.trim="addressLibraryForm.company" :placeholder='$t("key1000324")' :maxlength="255" clearable></Input>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1000068')" prop="email">
            <Input v-model.trim="addressLibraryForm.email" :placeholder='$t("key1000324")' :maxlength="255" clearable></Input>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="addressLibraryModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="addressLibraryBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "addressLibraryModal",
  mixins: [Mixin],
  props: {
    countrysOriginalData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      addressLibraryModal: false,
      addressLibraryTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002637'),
      addressLibraryForm: {
        addressName: '',
        city: '',
        company: '',
        countryCode: null,
        district: '',
        email: '',
        name: '',
        phone: '',
        postcode: '',
        state: '',
        street: '',
        street2: '',
        street3: '',
        servicePlatform: 'supplier',
      },
      ruleValidate: {
        addressName: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002668'), trigger: 'blur'}
        ],
        name: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002669'), trigger: 'blur'}
        ],
        countryCode: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002670'), trigger: 'change'}
        ],
        state: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002671'), trigger: 'blur'}
        ],
        city: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001154'), trigger: 'blur'}
        ],
        district: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001155'), trigger: 'blur'}
        ],
        street: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002672'), trigger: 'blur'}
        ],
        phone: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000147'), trigger: 'blur'}
        ],
        postcode: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002673'), trigger: 'blur'}
        ],
        email: [
          {trigger: 'blur', validator: v.validateMailboxFormat(false)}
        ],
      },
      addressLibraryType: 'add',
      ymsAddressTemplateId: null
    };
  },
  methods: {
    // 初始化数据
    initAddressLibraryData(type, ymsAddressTemplateId) {
      let v = this;
      let titleObj = {
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002637'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002674'),
        look: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002675')
      };
      v.ymsAddressTemplateId = ymsAddressTemplateId;
      v.addressLibraryType = type;
      v.addressLibraryTitle = titleObj[type];
      if (type !== 'add') {
        v.getAddressLibraryData(ymsAddressTemplateId);
      } else {
        v.$nextTick(() => {
          v.$refs['addressLibraryForm'].resetFields();
        });
        v.addressLibraryModal = true;
      }
    },
    // 获取地址的基本数据
    getAddressLibraryData(ymsAddressTemplateId) {
      this.axios.get(api.get_ymsSupplierAddressTemplate_detail + ymsAddressTemplateId, {loading: true}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            for (let key in this.addressLibraryForm) {
              this.addressLibraryForm[key] = data[key] || null;
            }
          }
          this.addressLibraryModal = true;
        }
      });
    },
    // 保存按钮
    addressLibraryBtn() {
      let v = this;
      let url = '';
      let method = '';
      let text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000113');
      let query = JSON.parse(JSON.stringify(v.addressLibraryForm));
      if (v.addressLibraryType === 'add') {
        url = api.post_ymsSupplierAddressTemplate_insert;
        method = 'post';
      } else if (v.addressLibraryType === 'edit') {
        url = api.put_ymsSupplierAddressTemplate_update;
        method = 'put';
        query.ymsAddressTemplateId = v.ymsAddressTemplateId;
      }
      v.$refs['addressLibraryForm'].validate((valid) => {
        if (valid) {
          v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.addressLibraryModal = false;
              v.$Message.success(text);
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 监听弹窗
    addressLibraryChange(value) {
      if (!value) {
        this.$nextTick(() => {
          this.$refs['addressLibraryForm'].resetFields();
        });
        this.addressLibraryType = 'add';
        this.addressLibraryTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002637');
        this.ymsAddressTemplateId = null;
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .addressLibraryStyle .promptStyle {
  position: absolute;
  top: 51%;
  right: -25px;
  transform: translateY(-50%);
}
</style>